import React, { createContext, useContext, useState, useCallback, Suspense, lazy } from 'react';

const WhatsAppLeadModal = lazy(() => import('@/components/ui/WhatsAppLeadModal'));

interface WhatsAppModalContextType {
  openWhatsAppModal: (source: string, customMessage?: string) => void;
}

const WhatsAppModalContext = createContext<WhatsAppModalContextType | null>(null);

export const useWhatsAppModal = () => {
  const ctx = useContext(WhatsAppModalContext);
  if (!ctx) throw new Error('useWhatsAppModal must be used within WhatsAppModalProvider');
  return ctx;
};

export const WhatsAppModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState('cta');
  const [customMessage, setCustomMessage] = useState<string | undefined>(undefined);

  const openWhatsAppModal = useCallback((src: string, msg?: string) => {
    setSource(src);
    setCustomMessage(msg);
    setMounted(true);
    setOpen(true);
  }, []);

  return (
    <WhatsAppModalContext.Provider value={{ openWhatsAppModal }}>
      {children}
      {mounted && (
        <Suspense fallback={null}>
          <WhatsAppLeadModal
            open={open}
            onOpenChange={setOpen}
            source={source}
            customMessage={customMessage}
          />
        </Suspense>
      )}
    </WhatsAppModalContext.Provider>
  );
};
